import React, { useEffect } from 'react';

interface SEOProps {
    title?: string;
    description?: string;
    noIndex?: boolean;
}

const SEO: React.FC<SEOProps> = ({ title, description, noIndex = true }) => {
    useEffect(() => {
        // Upravíme title
        if (title) {
            document.title = `${title} | TRINIS.EU`;
        }

        // Upravíme description meta tag
        let descriptionMeta = document.querySelector('meta[name="description"]');
        if (descriptionMeta && description) {
            descriptionMeta.setAttribute('content', description);
        }

        // Upravíme robots meta tag
        let robotsMeta = document.querySelector('meta[name="robots"]');
        if (!robotsMeta) {
            robotsMeta = document.createElement('meta');
            robotsMeta.setAttribute('name', 'robots');
            document.head.appendChild(robotsMeta);
        }

        // Ak noIndex je true, nastavíme noindex, nofollow
        // Ak noIndex je false, nastavíme index, follow
        const content = noIndex ? 'noindex, nofollow' : 'index, follow';
        robotsMeta.setAttribute('content', content);

        // Cleanup (optional, ale dobré ak by sme chceli vrátiť pôvodný stav pri unmountovaní)
        // V tomto prípade to necháme tak, lebo každá stránka si to nastaví sama
    }, [title, description, noIndex]);

    return null;
};

export default SEO;
